import * as yup from "yup";

export const buildValidationSchema = (fields) => {
    const shape = {};

    fields.forEach((field) => {
        let validator;
        const type = (field.type || "").toLowerCase();

        switch (type) {
            case "number":
                validator = yup.number().typeError("Please enter a valid number");
                if (field.validation?.min !== undefined) {
                    validator = validator.min(field.validation.min, `Minimum value is ${field.validation.min}`);
                }
                if (field.validation?.max !== undefined) {
                    validator = validator.max(field.validation.max, `Maximum value is ${field.validation.max}`);
                }
                break;

            case "email":
                validator = yup.string().email("Please enter a valid email address");
                break;

            case "date":
            case "birthdate":
                validator = yup
                    .string()
                    .transform((value, originalValue) => {
                        if (originalValue == null || originalValue === "") {
                            return originalValue;
                        }

                        // Mantine DateInput v8 emits YYYY-MM-DD strings; keep date-only format stable
                        if (originalValue instanceof Date) {
                            if (Number.isNaN(originalValue.getTime())) {
                                return originalValue;
                            }

                            const year = originalValue.getFullYear();
                            const month = String(originalValue.getMonth() + 1).padStart(2, "0");
                            const day = String(originalValue.getDate()).padStart(2, "0");
                            return `${year}-${month}-${day}`;
                        }

                        return typeof originalValue === "string" ? originalValue.trim() : originalValue;
                    })
                    .test("valid-date", "Please enter a valid date", (value) => {
                        if (value == null || value === "") return true;
                        if (typeof value !== "string") return false;
                        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

                        const parsed = new Date(`${value}T00:00:00.000Z`);
                        return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
                    });
                break;

            case "choice":
            case "conversion":
                validator = yup.string();
                break;

            case "multiplechoice":
                validator = yup.array().of(yup.string().trim());
                break;

            case "boolean":
                validator = yup.boolean();
                break;

            case "phone":
                validator = yup.string().test("not-only-prefix", "Please enter a valid phone number", (value) => {
                    if (value == null || value === "") return true;
                    const digitsOnly = (value || "").replace(/\D/g, "");
                    return digitsOnly.length > 3;
                });
                break;

            default:
                validator = yup.string();
                if (field.validation?.minLength) {
                    validator = validator.min(field.validation.minLength, `Minimum ${field.validation.minLength} characters`);
                }
                if (field.validation?.maxLength) {
                    validator = validator.max(field.validation.maxLength, `Maximum ${field.validation.maxLength} characters`);
                }
                if (field.validation?.pattern) {
                    validator = validator.matches(new RegExp(field.validation.pattern), "Invalid format");
                }
        }

        if (field.required) {
            if (type === "multiplechoice") {
                validator = validator.min(1, "This field is required").required("This field is required");
            } else {
                validator = validator.required("This field is required");
            }
        } else {
            validator = validator.nullable();
        }
        shape[field.name] = validator;
    });

    return yup.object().shape(shape);
};
